import { useCsrfToken } from '../../../core/hooks/useCsrfToken';
import { type DealNameValidateInputs, dealTitleValidate } from '../../services/deal';

/**
 * Hook that returns method to valdiate deal title
 *
 * @returns validate info
 */
export function useDealTitleValidate() {
    const csrfToken = useCsrfToken();

    async function validate(values: DealNameValidateInputs) {
        return await dealTitleValidate({
            ...values,
            ...csrfToken,
        });
    }

    return {
        validate,
    };
}
